import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface MetricCardProps {
  label: string;
  value: string;
  subValue?: string;
  trend?: number;
  trendLabel?: string;
  icon: string;
  iconColor?: string;
  variant?: 'default' | 'warning' | 'danger' | 'positive';
  className?: string;
}

export default function MetricCard({
  label,
  value,
  subValue,
  trend,
  trendLabel,
  icon,
  iconColor = 'text-primary',
  variant = 'default',
  className = '',
}: MetricCardProps) {
  const variantClass =
    variant === 'warning' ? 'card-glow-warning' :
    variant === 'danger'? 'card-glow-danger' : 'card-glow';

  const trendPositive = trend !== undefined && trend > 0;
  const trendNegative = trend !== undefined && trend < 0;

  return (
    <div className={`bg-card rounded-xl p-5 ${variantClass} ${className}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-2">{label}</p>
          <p className="text-metric-lg font-bold text-foreground font-tabular leading-none mb-1">{value}</p>
          {subValue && <p className="text-xs text-muted-foreground mt-1">{subValue}</p>}
          {trend !== undefined && (
            <div className={`flex items-center gap-1 mt-2 text-xs font-medium ${
              trendPositive ? 'text-positive' : trendNegative ? 'text-negative' : 'text-muted-foreground'
            }`}>
              <Icon
                name={trendPositive ? 'ArrowTrendingUpIcon' : trendNegative ? 'ArrowTrendingDownIcon' : 'MinusIcon'}
                size={12}
              />
              <span>{trend > 0 ? '+' : ''}{trend}%</span>
              {trendLabel && <span className="text-muted-foreground font-normal">{trendLabel}</span>}
            </div>
          )}
        </div>
        <div className={`p-2.5 rounded-xl bg-muted shrink-0 ${iconColor}`}>
          <Icon name={icon as Parameters<typeof Icon>[0]['name']} size={20} />
        </div>
      </div>
    </div>
  );
}